<template>
  <div class="choose-funding-request-type-container">
    <div>
      <div class="card" @click="nextStep(BillType.CASH_ADVANCE)">
        <div class="left-side">
          <span data-cy="cash-advance-title" class="title">
            {{ $t('account.pages.pageVendors.cashAdvance') }}
          </span>
          <span data-cy="cash-advance-description">
            {{
              $t(
                'account.pages.pageVendors.chooseFundingRequestType.cashAdvanceSubtitle',
              )
            }}
          </span>
        </div>
        <div class="right-side">
          <i class="pi pi-chevron-right icon"></i>
        </div>
      </div>
      <div class="card" @click="nextStep(BillType.INVOICE)">
        <div class="left-side">
          <span data-cy="invoice-title" class="title">
            {{ $t('account.pages.pageVendors.invoice') }}
          </span>
          <span data-cy="invoice-description">
            {{
              $t(
                'account.pages.pageVendors.chooseFundingRequestType.invoiceSubtitle',
              )
            }}
          </span>
        </div>
        <div class="right-side">
          <i class="pi pi-chevron-right icon"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import analytics, { SEGMENT_EVENTS } from '@/utils/analytics';
import { BillType } from '@/@types/bill.types';

export default {
  props: {
    directUserToBillModal: {
      type: Boolean,
      default: false,
    },
  },
  async mounted() {
    analytics.track(SEGMENT_EVENTS.VIEWED_SUBMISSION_TYPE_MODAL);

    await this.$store.dispatchApiAction('GET_BILL_SCHEMA');

    if (this.directUserToBillModal) {
      this.$emit('amount', 0);
      this.$emit('next-tab');
    }
  },
  data() {
    return {
      BillType,
    };
  },
  methods: {
    async nextStep(step) {
      analytics.track(SEGMENT_EVENTS.fe_submission_type_clicked, {
        type: step,
      });
      await this.$store.dispatch('UPDATE_BILL_FLOW_TYPE', step);
      this.$emit('amount', 0);
      this.$emit('next-tab');
    },
  },
};
</script>

<style lang="less">
.choose-funding-request-type-container {
  .card {
    display: flex;
    flex-direction: row;
    margin: 0;
    padding: 15px 25px;
    color: @color-grey-500;
    font-weight: 100;
    font-family: @regular-font;
    box-shadow: 0 3px 6px 0 @color-grey-200;
    border-radius: 4px;
    max-width: 500px;
    height: 140px;
    cursor: pointer;

    &:hover {
      box-shadow: 0 4px 8px @color-grey-300;
    }

    & ~ .card {
      margin-top: 20px;
    }

    .left-side {
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      text-align: left;
      width: 90%;

      .title {
        font-size: 20px;
        font-weight: bold;
        color: @black;
        font-family: @regular-font;
      }
    }

    .right-side {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      width: 10%;

      i {
        font-size: 1.5rem;
      }
    }
  }
}
</style>
